import { Component } from '@angular/core';

@Component({
    selector: 'ui-header-menu',
    templateUrl: './header-menu.component.html',
    styleUrls: ['./header-menu.component.less']
})
export class HeaderMenuComponent {
    readonly iconLink = '/assets/img/icons/link.svg';
}
